<template>
  <div class="content">
    <div class="search-area">
      <div class="w100f t-left mb15"><b>选择需要导入的数据</b></div>
      <div class="import-a-sty">
        <a class="fontC-4fa1a4">人员管理导入</a><label></label>
        <!-- <a @click="toLink('/importFreightQuotation')">运费报价导入</a> <label> | </label> -->
        <!-- <a @click="toLink('/importWarehouseQuotation')">仓储报价导入</a>  -->
      </div>
    </div>
    <div class="search-area mt15">
      <div class="import-sty">
        <el-steps :active="active" align-center>
          <el-step title="上传文件"></el-step>
          <el-step title="导入结果"></el-step>
          <!-- <el-step title="导入完成"></el-step>  -->
        </el-steps>
        <div v-if="active == 0">
          <div class="ml71">
                <div class="mt50 ">药企名称：{{$route.query.tenantName}}</div> 
                <div class="mt15">下载模板：<el-button plain size="medium" @click="uploadExcel">下载文件模板</el-button></div>
                <div class="mt15 mt15 h120"><p class="fl">导入文件：</p>
                <!-- <el-button size="medium" type="info" @click="add(1, '')">点击上传文件</el-button> -->
                      <el-upload
                        class="upload-demo fl"
                        action="#"  
                        :before-upload="beforeUpload"
                        multiple
                        :limit="1"
                        accept=".xlsx,.xsl,.xls,.xlsm"
                        :auto-upload="false"
                        :file-list="fileList"
                        :on-change="changeFile"
                        :on-exceed="handleExceed">
                        <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading">点击上传文件</el-button>
                        <div slot="tip" class="el-upload__tip">
                        当前仅支持 excel 格式文件（大小在5M以内），请使用 Office 2010 及以上版本，否则可能出现乱码<br>
                        必须严格按照模板内容填入数据，否则可能会出现导入异常
                        </div>
                      </el-upload>
                </div> 
          </div> 
          <div class="mt15 t-right">
                <!-- <el-button size="medium" plain @click="add(1, '')">取消</el-button> -->
                <!-- <el-button size="medium" type="info" @click="next()">下一步</el-button> -->
          </div> 
    </div> 
      </div>
      <div v-if="active == 1" class="mt15">
        <div class="summary-text-sty">
          <div class="text-hz">
            预计上传<b class="fontC-4fa1a4 font-S18"> {{ dataAllSum }} </b>条数据，已上传成功<b
              class="fontC-4fa1a4 font-S18"
            >
              {{ dataSuccessSum }} </b
            >条，错误数据<b class="fontC-red font-S18"> {{ dataErrorSum }} </b>条
          </div>
          <el-button size="medium" class="w145 mt30" plain @click="returnActive()">返回</el-button>
          <el-button
            size="medium"
            icon="el-icon-download"
            v-if="dataErrorSum != 0"
            class="mt30"
            type="info"
            @click="report"
            v-loading.fullscreen.lock="fullscreenLoading"
            >下载错误数据</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="showImport"
      width="560px"
      height="120px"
      :show-close="false"
      :before-close="handleClose"
    >
      <div class="progress-box">
        <p class="mb10 mt0">正在上传：{{ num }}%</p>
        <el-progress :stroke-width="12" :percentage="num"></el-progress>
      </div>
    </el-dialog>
    <!-- <div class="model-bg" v-if="showImport">
              <img class="t-center" style="margin-top:15%;" src="../../assets/images/roll.gif" width="40"><br>
              {{num}}%
            </div> -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      url:
        `/${serverConfig.msPersonnelService}/import-data/import-tenant-filing-staff?tenantGuid=` +
        this.$store.state.guid +
        '&sendTenantGuid=' +
        this.$route.query.sendTenantGuid+
        `&checkFillingsFlag=1`,
      active: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importType: '0001',
        errorFlag: '',
      },
      fileList: [],
      showImport: false,
      importSum: 0,
      loading: true,
      tableData: [],
      provinceList: areaJson,
      cityList: [],
      districtList: [],
      guids: [],
      errorRows: 0,
      totalRows: 0,
      fullscreenLoading: false,
      dataAllSum: 0,
      dataSuccessSum: 0,
      dataErrorSum: 0,
      msg: '',
      num: 0,
      intervalSum: '',
      isAllocateNo:false
    };
  },
  created() {
    // this.getAllocateNo()
    // this.src = '';
    // this.getSrc();
  },
  watch: {},
  mounted() {},
  methods: {
    returnActive() {
      this.active = 0;
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      // .then(_ => {
      //   done();
      // })
      // .catch(_ => {});
    },
    //是否存在有货位ID的
    getAllocateNo() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=1aaf025422ff11eb9405080027ac9e40&code=ZSHWID`,
        )
        .then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            let arr = [];
            data.forEach((item) => {
              if(item.parameterValue == this.$route.query.sendTenantGuid){
                this.isAllocateNo = true;
              }
            });
          }
        });
    },
    toLink(link) {
      this.$router.push({ path: link });
    },
    province(pr) {
      let self = this;
      self.cityList = [];
      self.provinceList.forEach(function (i) {
        if (i.label == pr) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.cityList.push(j);
            });
          }
        }
      });
    },
    city(ci) {
      let self = this;
      console.log(self.cityList);
      self.districtList = [];
      self.cityList.forEach(function (i) {
        if (i.label == ci) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.districtList.push(j);
            });
          }
        }
      });
    },
    uploadExcel() {
      window.open('/药企备案人员导入模板(货位ID).xlsx');
    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file, fileList) {
      let self = this;
      self.num = 0;
      let isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        self.$message.error('上传文件大小不能超过 5MB');
        file = null;
        fileList = [];
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
      } else {
        let formData = new FormData();
        formData.append('file', file.raw); //传文件
        let progressGuid = self.generateUUID();
        let url = self.url + '&progressGuid=' + progressGuid;
        self.intervalSum = setInterval(function () {
          self.getImportProgress(progressGuid);
        }, 1000);
        self.api.postFile(url, formData).then(function (res) {
          self.fileList = [];
          clearInterval(self.intervalSum);
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.showImport = false;
            self.num = 0;
            self.$message({
              type: 'success',
              message: '上传成功',
            });
            self.active = 1;
            if (res.data.data) {
              self.dataAllSum = res.data.data.split(',')[0];
              self.dataSuccessSum = res.data.data.split(',')[1];
              self.dataErrorSum = self.dataAllSum - self.dataSuccessSum;
            }
          } else {
            self.fullscreenLoading = false;
            self.showImport = false;
            self.num = 0;
            self.$message({
              type: 'warning',
              message: res.data.msg,
            });
          }
        });
      }
    },
    getImportProgress(progressGuid) {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msCommonAdminCloudService}/excel/import/get-import-progress?guid=` + progressGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.num = res.data.data;
              if (100 > self.num > 0) {
                self.showImport = true;
              }
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    report() {
      let self = this;
      self.fullscreenLoading = true;
      // self.page.performanceGuid = self.$router.history.current.query.guid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/import-data/get-import-tenant-filing-staff-error-data?sendTenantGuid=` +
            this.$route.query.sendTenantGuid,
        )
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.active = 0;
            self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
  },
};
</script>
<style  scoped>
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/deep/ .el-dialog__header {
  display: none;
}
/deep/ .el-progress__text {
  display: none;
}
/deep/ .el-progress-bar__inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #4fa1a4;
  text-align: right;
  border-radius: 100px;
  line-height: 1;
  white-space: nowrap;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}
.summary-text-sty {
  width: 70%;
  height: 158px;
  border: 2px dashed #b4b4b4;
  margin: 0 auto;
  background: #f7f7f7;
}
.text-hz {
  margin-top: 36px;
  font-size: 16px;
}
.model-bg {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 1001;
  -moz-opacity: 0.6;
  opacity: 0.6;
  filter: alpha(opacity=60);
  color: white;
}
.w145 {
  width: 145px;
}
</style>